import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyBuyerConfigApi } from '../api/company-buyer-config.api';
import {
  BuyerConfigSettingsForm,
  BuyerConfigSettingsSavePayload,
  BuyerCountrySettingsSavePayload,
} from '../models/company-buyer-config.model';

@Injectable({ providedIn: 'root' })
export class CompanyBuyerConfigService {
  private readonly _buyerConfigApi = inject(CompanyBuyerConfigApi);

  public buyerConfigSettings(
    buyerId: number,
  ): Observable<BuyerConfigSettingsForm> {
    return this._buyerConfigApi.buyerConfigSettings(buyerId);
  }

  public saveBuyerConfigSettings(
    payload: BuyerConfigSettingsSavePayload,
  ): Observable<string> {
    return this._buyerConfigApi.saveBuyerConfigSettings(payload);
  }

  public saveBuyerCountrySettings(
    payload: BuyerCountrySettingsSavePayload,
  ): Observable<string> {
    return this._buyerConfigApi.saveBuyerCountrySettings(payload);
  }

  public resetToDefault(buyerId: number): Observable<string> {
    return this._buyerConfigApi.resetToDefault(buyerId);
  }
}
